import { useState } from 'react';

import { useAppSelector, useAppDispatch } from 'hooks';

import { Text, Box, Button, Flex, Collapse, Icon } from '@chakra-ui/react';

import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

import Card from 'components/card/Card';

import Divider from 'views/auto_form/components/Divider';

import {
  changeAccidentsAndClaims,
  addAccidentsAndClaims,
  removeAccidentsAndClaims,
  changeOtherLoss,
  addOtherLoss,
  removeOtherLoss,
} from 'reducers/autoPersonalFormReducer';

import Claim from './components/Claim';

import useIsBinderDisabled from 'views/auto_form/hooks/useIsBinderDisabled';

import getDateString from 'helpers/getDateString';

const Claims = () => {
  const dispatch = useAppDispatch();

  const [isCollapsed, setIsCollapsed] = useState(true);

  const claims = useAppSelector(
    (state) => state.autoPersonalForm.data.accidents_and_claims,
  );

  const other_losses = useAppSelector(
    (state) => state.autoPersonalForm.data.other_losses,
  );

  const isDisabled = useIsBinderDisabled(true);

  const onClaimChange = (event: any, index: number) => {
    const { name, value, checked, type } = event.target;
    const payload = type === 'checkbox' ? checked : value;

    dispatch(changeAccidentsAndClaims({ name, index, value: payload }));
  };

  const onClaimDateChange = (date: Date, name: string, index: number) => {
    dispatch(
      changeAccidentsAndClaims({ name, index, value: getDateString(date) }),
    );
  };

  const onOtherLossChange = (event: any, index: number) => {
    const { name, value, checked, type } = event.target;
    const payload = type === 'checkbox' ? checked : value;

    dispatch(changeOtherLoss({ name, index, value: payload }));
  };

  const onOtherLossDateChange = (date: Date, name: string, index: number) => {
    dispatch(changeOtherLoss({ name, index, value: getDateString(date) }));
  };

  return (
    <Card mb="20px" id="sectionClaims">
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontWeight="bold" fontSize="xl">
          Accidents and Claims Summary{' '}
          <Text textColor="red" display="inline">
            (dev mode)
          </Text>
        </Text>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsCollapsed(!isCollapsed)}
          rightIcon={
            <Icon as={isCollapsed ? ChevronDownIcon : ChevronUpIcon} />
          }
        >
          {isCollapsed ? 'Expand' : 'Collapse'}
        </Button>
      </Flex>

      <Collapse in={!isCollapsed} animateOpacity>
        <Text fontSize="xs" mt="20px">
          Give details of all accidents or claims arising from the ownership,
          use or operation of any automobile by the applicant or any listed
          driver during the last 6 years. The coverages are: BI - Bodily Injury,
          PD - Property Damage, AB - Accident Benefits, DCPD - Direct ,
          Compensation - Property Damage, UA - Uninsured Automobile, Coll-
          Collision, AP - All Perils, Comp - Comprehensive, SP - Specified
          Perils
        </Text>

        {claims.map((claim, index) => {
          return (
            <Claim
              key={index}
              index={index}
              claim={claim}
              onChange={onClaimChange}
              onDateChange={onClaimDateChange}
              onRemoveClaim={() => dispatch(removeAccidentsAndClaims(index))}
              isDisabled={isDisabled}
            />
          );
        })}

        {!isDisabled && (
          <Box mt="20px">
            <Button
              variant="brand"
              onClick={() => dispatch(addAccidentsAndClaims())}
            >
              Add new
            </Button>
          </Box>
        )}

        {other_losses.length > 0 && (
          <>
            <Divider mt="20px">Other Losses</Divider>

            {other_losses.map((other_loss, index) => {
              return (
                <Claim
                  key={index}
                  index={index}
                  claim={other_loss}
                  onChange={onOtherLossChange}
                  onDateChange={onOtherLossDateChange}
                  onRemoveClaim={() => dispatch(removeOtherLoss(index))}
                  isDisabled={isDisabled}
                />
              );
            })}

            {!isDisabled && (
              <Box mt="20px">
                <Button
                  variant="brand"
                  onClick={() => dispatch(addOtherLoss())}
                  disabled={isDisabled}
                >
                  Add new
                </Button>
              </Box>
            )}
          </>
        )}
      </Collapse>
    </Card>
  );
};

export default Claims;
